import React from "react";
import {FaHeart} from 'react-icons/fa'
const Footer = () => {
  return (
    <div className="footer">
      <p>
        Design With <FaHeart className="footer_icon" />  By Hamed
      </p>
    </div>
  );
};

export default Footer;
